import { useEffect } from "react";
import { doLogout } from "helpers/logout";
import { useDispatch } from "react-redux";

export default function ToLogin() {
  const dispatch = useDispatch();

  useEffect(() => {
    doLogout(dispatch, 'Browser session cookie expired. Logging out user automatically', true, '/login', false);
  }, []);

  return <div className="text-center p-5" data-testid="loading">
    <div className="spinner-border">
      <span className="sr-only">Wird geladen...</span>
    </div>
    <div>Abmeldung wird durchgeführt...</div>
  </div>;
}
